import { Dispatch } from 'redux';
import { openDialog } from 'stash/actions/dialog';
import { Text } from '@stashinvest/react-components';
import DynamicDisclosure from 'stash/components/dynamic-disclosure/DynamicDisclosure';
import { Amount, Plan, TooltipInfo } from 'stash/components/subscription/manage/types';
import React from 'react';

/**
 * Opens a dialog to display tooltip information
 * @param tooltip The tooltip info containing title and body
 * @param dispatch Redux dispatch function
 * @param confirmText Text for the dismiss button
 * @returns A promise that resolves when the dialog is closed
 */
export const openTooltipDialog = async (
	tooltip: TooltipInfo,
	dispatch: Dispatch<any>,
	confirmText: string
): Promise<void> => {
	try {
		await dispatch(
			openDialog({
				heading: tooltip.title,
				prompt: React.createElement(
					Text,
					//@ts-ignore
					{ textAlign: 'left' },
					React.createElement(DynamicDisclosure, { dynamicCopy: tooltip.body })
				),
				confirmText,
				shouldRenderHelpLink: false,
				align: 'left',
			})
		);
	} catch (error) {
		// Silent catch, but we could add logging here if needed
		console.debug('Dialog open error:', error);
	}
};

/**
 * Combines current plan and eligible plans into a single array of plans
 * @param currentPlan Array of current user plans
 * @param eligiblePlans Array of plans the user is eligible for
 * @returns Combined array of plans
 */
export const combinePlans = (
	currentPlan: Plan | undefined,
	eligiblePlans: Plan[] = []
): Plan[] => {
	const allPlans = currentPlan ? [currentPlan, ...eligiblePlans] : eligiblePlans;
	return allPlans.sort((x, y) => x.ordering - y.ordering);
};

export const hasGreaterThanZeroValue = (amount: Amount | undefined): boolean => {
	return parseFloat(amount?.value || '0') > 0;
};
